import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("top-title", [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("产品方案")))])]), _c("a-button", {
    attrs: {
      type: "add",
      icon: "plus"
    },
    on: {
      click: _vm.handleAdd
    }
  }, [_vm._v(_vm._s(_vm.$t("新增") + _vm.$t("方案")))]), _c("a-button", {
    staticStyle: {
      float: "right"
    },
    attrs: {
      type: _vm.data.length && _vm.isComparison() ? "primary" : "",
      disabled: !_vm.data.length || !_vm.isComparison()
    },
    on: {
      click: _vm.configBudget
    }
  }, [_vm._v(_vm._s(_vm.$t("保费试算")))]), _c("a-table", {
    staticClass: "marginT20",
    attrs: {
      bordered: "",
      hideOnSinglePage: true,
      columns: _vm.columns,
      "data-source": _vm.data,
      align: "center",
      pagination: false,
      rowKey: "id"
    },
    on: {
      change: _vm.handleStandardTableChange
    },
    scopedSlots: _vm._u([{
      key: "mark",
      fn: function (text) {
        return [_vm._v(_vm._s(text ? text : "-"))];
      }
    }, {
      key: "name",
      fn: function (text, record) {
        return [_vm._v(_vm._s(text) + " "), record.isDefault == 1 ? _c("span", {
          staticClass: "default"
        }, [_vm._v(_vm._s(_vm.$t("默认方案")))]) : _vm._e()];
      }
    }, {
      key: "code",
      fn: function (text) {
        return [_vm._v(_vm._s(text ? text : "-") + " ")];
      }
    }, {
      key: "duration",
      fn: function (text) {
        return [_vm._v(_vm._s(_vm.getDuration(text)))];
      }
    }, {
      key: "price",
      fn: function (text, record) {
        return [_vm._v(_vm._s(record.priceType === "AREA_PRICE" ? _vm.getAreaPrice(record) : text))];
      }
    }, {
      key: "status",
      fn: function (text, record) {
        return [_c("a-switch", {
          attrs: {
            checked: text == 1 ? true : false
          },
          on: {
            click: function ($event) {
              return _vm.checkedFun(record);
            }
          }
        })];
      }
    }, {
      key: "action",
      fn: function (text, record, i) {
        return [_c("a-button", {
          staticClass: "marginR15",
          attrs: {
            type: "edit",
            size: "small"
          },
          on: {
            click: function ($event) {
              return _vm.handleEdit(record, i);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("编辑")))]), _c("a-button", {
          staticClass: "marginR15",
          attrs: {
            type: "copy",
            size: "small"
          },
          on: {
            click: function ($event) {
              return _vm.onCopy(record, undefined, true);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("复制")))]), _c("a-button", {
          attrs: {
            type: "danger",
            size: "small"
          },
          on: {
            click: function ($event) {
              return _vm.handleDelete(i, record);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("删除")))])];
      }
    }])
  }, _vm._l(_vm.columns, function (item, i) {
    var _item$slots, _item$slots2, _item$slots3;
    return _c("span", {
      key: i,
      attrs: {
        slot: (_item$slots = item.slots) === null || _item$slots === void 0 ? void 0 : _item$slots.title
      },
      slot: (_item$slots2 = item.slots) === null || _item$slots2 === void 0 ? void 0 : _item$slots2.title
    }, [_vm._v(_vm._s(_vm.$t((_item$slots3 = item.slots) === null || _item$slots3 === void 0 ? void 0 : _item$slots3.title)))]);
  }), 0), _c("div", {
    staticClass: "btnBox marginT20"
  }, [_c("a-button", {
    staticStyle: {
      "margin-right": "20px"
    },
    on: {
      click: function ($event) {
        return _vm.$emit("prev");
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("上一步")))]), _c("a-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.onSavePlan
    }
  }, [_vm._v(_vm._s(_vm.$t("提交")))])], 1), _vm.palnShow ? _c("plan-model", {
    ref: "planForm",
    attrs: {
      id: _vm.id,
      saveTagList: _vm.tagList,
      tableData: _vm.data,
      params: {
        unitId: _vm.info.unitId,
        agencyId: _vm.info.agencyId,
        insurancePlanId: _vm.id
      }
    },
    on: {
      cancel: function ($event) {
        _vm.palnShow = false;
      },
      ok: _vm.handleOk,
      getSavePlan: _vm.getSavePlan,
      tagList: _vm.getSaveTags
    }
  }) : _vm._e(), _c("comparison-model", {
    attrs: {
      visible: _vm.comparisonVisible,
      info: _vm.comparisonList
    },
    on: {
      cancel: function ($event) {
        _vm.comparisonVisible = false;
      }
    }
  }), _c("budget-model", {
    ref: "budgetRef",
    attrs: {
      id: _vm.id,
      visible: _vm.budgetVisible,
      budgetForm: _vm.budget,
      info: _vm.paramsList,
      list: _vm.data.filter(item => item.status == 1),
      formParams: _vm.formParams,
      preview: _vm.previewData
    },
    on: {
      onSaveBudget: _vm.onSaveBudget,
      cancel: _vm.cancelBudget
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };